import { defaultBcpLocale } from '../definitions';

export interface LocaleState {
  currentBcpLocale: string;
  isLocked: boolean;
}

export const InitialLocaleState = {
  currentBcpLocale: defaultBcpLocale,
  isLocked: false
};
